import { render, staticRenderFns } from "./PolicyNotice.vue?vue&type=template&id=5d422ef4"
import script from "./PolicyNotice.vue?vue&type=script&lang=js"
export * from "./PolicyNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PolicyNotice.vue"
export default component.exports